import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import RallyThemesRow from '../RallyThemesRow';
import RallyLocationRow from '../RallyLocationRow';
import RallyTargetGroupRow from '../RallyTargetGroupRow';
import Button from '../Button';
import { useTranslation } from 'react-i18next';
import AnalyticsIcon from '../../assets/icons/analytics.svg';
import PenIcon from '../../assets/icons/pen.svg';
import CompleteRallyIcon from '../../assets/icons/complete.svg';
import IncompleteRallyIcon from '../../assets/icons/incomplete.svg';
import Switch from '../Switch';
import ButtonsGroup from '../ButtonsGroup';
import { generateIdRoutePath } from '../../helpers';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '../../assets/icons/delete.svg';
import { activateAdminRally, updateAdminRally } from '../../api/admin/rallies';
import { useAppDispatch } from '../../store';
import { setIsModalOpen, setModalContent, setModalContentProps } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { useSelector } from 'react-redux';
import { selectRallyToDeactivateId, setRallyToDeactivateId } from '../../store/adminSlices/rallies';
import CopyIcon from '../../assets/icons/copy.svg';
const AdminRallyInfoCard = ({ uid, themes, title, internalTitle, targetGroups, isActive, isComplete, hasStatistic, hasLocation = false, uuid, }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isSwitchChecked, setIsSwitchChecked] = useState(isActive);
    const [updateRallyStatus, setUpdateRallyStatus] = useState(null);
    const rallyToDeactivateId = useSelector(selectRallyToDeactivateId);
    useEffect(() => {
        setIsSwitchChecked(isActive);
    }, [isActive]);
    useEffect(() => {
        const handleDeactivateRally = async () => {
            setUpdateRallyStatus('pending');
            dispatch(setRallyToDeactivateId(null));
            try {
                await updateAdminRally(String(rallyToDeactivateId), {
                    isActive: false,
                });
                setUpdateRallyStatus('success');
                setIsSwitchChecked(false);
            }
            catch (error) {
                setUpdateRallyStatus('error');
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        if (rallyToDeactivateId === uid) {
            handleDeactivateRally();
        }
    }, [rallyToDeactivateId]);
    const handleSwitchChange = async () => {
        if (isSwitchChecked) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.deactivateRally.key));
            dispatch(setModalContentProps({
                rallyId: uid,
            }));
        }
        else {
            if (!isComplete || updateRallyStatus === 'pending') {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.cannotPublishRally.key));
                dispatch(setModalContentProps({
                    rallyId: uid,
                }));
            }
            else {
                try {
                    setUpdateRallyStatus('pending');
                    await activateAdminRally(String(uid));
                    setIsSwitchChecked(!isSwitchChecked);
                    setUpdateRallyStatus('success');
                    navigate(generateIdRoutePath(APP_ROUTES.adminPublishedRally, uuid));
                }
                catch (error) {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                    setUpdateRallyStatus('error');
                }
            }
        }
    };
    const onDeleteRally = () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.confirmDeleteRally.key));
        dispatch(setModalContentProps({
            rallyId: uid,
        }));
    };
    const onDuplicateRally = () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.confirmCopy.key));
        dispatch(setModalContentProps({
            unit: 'rally',
            rallyId: uid,
            rallyTitle: title,
            rallyInternalTitle: internalTitle,
        }));
    };
    return (_jsxs("div", { className: "admin-rally-info-card", children: [_jsx(RallyThemesRow, { themes: themes }), _jsxs("div", { className: "admin-rally-info-card-wrapper", children: [_jsxs("div", { className: "rally-info", children: [title && _jsx("div", { className: "rally-title", children: title }), internalTitle && _jsx("div", { className: "rally-internal-title", children: internalTitle }), _jsxs("div", { className: "rally-details", children: [hasLocation && _jsx(RallyLocationRow, {}), _jsx(RallyTargetGroupRow, { targetGroups: targetGroups })] })] }), _jsxs("div", { className: "rally-controls", children: [_jsxs("div", { className: "controls-wrapper", children: [_jsx("div", { className: "rally-switcher", children: _jsx(Switch, { checked: isSwitchChecked, onChange: handleSwitchChange, labelLeft: t('label.active'), labelRight: t('label.inactive') }) }), _jsx("div", { className: "rally-status", children: isComplete ? _jsx(CompleteRallyIcon, {}) : _jsx(IncompleteRallyIcon, {}) })] }), _jsxs(ButtonsGroup, { wrap: 'nowrap', children: [hasStatistic && (_jsx(Button, { onClick: () => navigate(generateIdRoutePath(APP_ROUTES.adminRallySessions, String(uid))), label: t('button.analytics'), variant: 'outlined', icon: _jsx(AnalyticsIcon, {}), manageIcon: 'fill' })), _jsx(Button, { onClick: () => navigate(generateIdRoutePath(APP_ROUTES.adminEditRally, String(uid))), label: t(isComplete ? 'button.edit' : 'button.edit_draft'), variant: 'outlined', icon: _jsx(PenIcon, {}), manageIcon: 'fill' }), _jsx(Button, { onClick: () => navigate(generateIdRoutePath(APP_ROUTES.adminManageTasks, String(uid))), label: t('admin.manage_tasks'), variant: 'outlined' }), _jsx(Button, { onClick: onDuplicateRally, variant: 'outlined', shape: 'square', icon: _jsx(CopyIcon, {}), manageIcon: 'fill' }), _jsx(Button, { onClick: onDeleteRally, variant: 'outlined', shape: 'square', icon: _jsx(DeleteIcon, {}), manageIcon: 'fill' })] })] })] })] }));
};
export default AdminRallyInfoCard;
